import { DataClassifierType } from '@ariksa/data-scanning/api';
import { map } from 'lodash';

import { toTitleCase } from 'utils/string';

export const dataClassificationTypeOptions = map(DataClassifierType, o => ({
  label: toTitleCase(o),
  value: o,
}));
